import React, {useEffect} from "react";
import Modal from "react-bootstrap/esm/Modal";
import Spinner from "react-bootstrap/Spinner";
import ReactHtmlParser from "react-html-parser";
import {VerifySuccessIcon} from "../common/Icons";

const PhoneConfirmSuccess = ({user_profile, sms_code_state}) => {
    useEffect(() => {
        if(sms_code_state === 3){
            setTimeout(() => {
                window.location.reload();
            }, 3000)
        }
    })

    let data = {
        title: 'Verification in Progress',
        subtitle: 'Please wait while we verify your phone number',
        icon: <Spinner animation="border" />
    };
    if(sms_code_state === 3){
        data = {
            title: 'Verification Successful',
            subtitle: `<strong>${user_profile.main_phone}</strong> is verified and associated with your account`,
            icon: <VerifySuccessIcon
                style={{width: 103}}
                className=""
                label="Verification Successful"
                color="#6FCF97"
            />
        }
    }

    return (
        <Modal
            show={true}
            size="md"
            centered
            onHide={null}
            className="phone-confirm-modal rbg-popup-generic"
            container={document.getElementById('react-popup-container')}
            backdropClassName="dark-overlay"
        >
            <Modal.Body className="rbg-popup-generic__body">
                <div className="phone-confirm-modal__title">
                    {data.title}
                </div>
                <div className="phone-confirm-modal__text">
                    {ReactHtmlParser(data.subtitle)}
                </div>
                <div className="phone-confirm-modal__icon-container">
                    {data.icon}
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default PhoneConfirmSuccess;